import React from 'react';
import fetch from '../../fetch';
import utils from '../../../utils';
import {Tag} from 'antd'

const DataGrid = {
    selections: [],
    refresh: function() {

    }
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelect = (ids) => {
    DataGrid.selections = ids;
}


/**
 * @method setRefresh
 * @param {function} callback
 * @return {promise}
 */
const setRefresh = (callback) => {
    DataGrid.refresh = callback;
};


const getSelection =() => {
    return DataGrid.selections;
}
const columns = utils.columns([
    {key:'$index', label: '序号' , width : 80},
    {key:'orgName', label: '部门名称',width : 100},
    {key:'majorName', label: '专业名称' ,width : 100},
    {key:'classesName', label: '班级名称' ,width : 100},
    {key:'studentName', label: '学生姓名' ,width : 100},
    // {key:'title', label: '论文题目' ,width : 100},
    {key: 'status', label:'状态' , width : 100 , render:(val)=>{
        if(val === 0){
            return <Tag color='#2db7f5'>待分配评审专家</Tag>
        }else if(val === 1){
            return <Tag color='#2db7f5'>待审核</Tag>
        }else if(val === 2){
            return <Tag color='#87d068'>审核中</Tag>
        }else if(val === 3){
            return <Tag color='#108ee9'>待复核</Tag>
        }else if(val === 4){
            return <Tag color='#87d068'>复核中</Tag>
        }else if(val === 5){
            return <Tag color='#f50'>不合格</Tag>
        }else if(val === 6){
            return <Tag color='#87d068'>合格</Tag>
        }
    } },
    {key:'masterName', label: '评审专家' ,width : 130},
    {key: 'batchNo', label:'批次' , width : 100 },
    {key:'employeeName', label: '指导教师' ,width : 130},
    {key:'termName', label: '学期' ,width : 120},
]);

const querySearch = (keywords = {pageNum: 1, pageSize: 100}) => {
    let params = []
    if(keywords['sort'] != '$index') {
        for(var i in keywords) {
            if(i === 'order') {
                params.push(`order=${keywords[i]}`)
            }
            if(i === 'sort') {
                params.push(`sort=${keywords[i]}`)
            }
        }
    }
    params.push(`pageNum=${keywords.pageNum}`)
    params.push(`pageSize=${keywords.pageSize}`)
    return fetch.post('/graduation/check/query?' + params.join('&'), keywords)
    .then(response => {
        return response.payload.data;
    })
    .then(data => (Object.assign({
        result: data.dataList || [],
        selects: (data.dataList || []).map(d => ({
            value: d.id,
            checked: false
        })),
        checked: false,
        total: data.total,
        pageIndex: data.pageNum,
        pageSize: data.pageSize,
        notify: (data.dataList || []).length ? '' : '暂无数据...'
    })));
}

const generate = (data)=>{
    return fetch.post('graduation/check/generate' , data)
}

const remove = (keywords) => {
    return fetch.post('graduation/check/delete' , keywords)
}

const distributeMaster = (data)=>{
    return fetch.post('graduation/check/distributeMaster' , data)
}

const getCheckMasterById = (id) => {
    return fetch.post(`graduation/check/getCheckMaster/${id}` , {})
}

const updateMaster = (id , params) => {
    return fetch.post(`graduation/check/updateMaster/${id}` ,params)
}

const getDetailById = (id)=> {
    return fetch.get(`graduation/check/getDetailById/${id}`)
}

const approval = (data) => {
    return fetch.post(`graduation/check/approval` ,data)
}

export default {
    columns,
    onSelect,
    setRefresh,
    getSelection,
    querySearch ,
    generate ,
    delete : remove,
    distributeMaster,
    getCheckMasterById ,
    updateMaster ,
    getDetailById ,
    approval
}